// src/routes/AddParfume/index.tsx
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage, auth } from "../../firebase";
import { v4 as uuid } from "uuid";
import "./index.css";
import Loading from "../Loading";
import logo from "../../assets/originelogo.png";
import AssosiationHelper from "../../components/AssosiationHelper";

type Parfume = {
  id: string;
  userId: string;
  name: string;
  img?: string;
  description?: string;
};

type User = {
  id: string;
  email: string;
  name: string;
  status: string;
};

export default function CreateParfume() {
  const nav = useNavigate();

  const [me, setMe] = useState<User | null>(null);
  const [parfumes, setParfumes] = useState<Parfume[]>([]);
  const [loading, setLoading] = useState(true);

  // форма
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [busy, setBusy] = useState(false);

  const dropRef = useRef<HTMLDivElement | null>(null);

  async function fetchProfile() {
    setLoading(true);
    try {
      const u = await api<{ ok: true; user: User }>("/client/me", {
        method: "GET",
      });
      const p = await api<{ ok: true; parfumes: Parfume[] }>(
        "/client/parfumes",
        { method: "GET" }
      );
      setMe(u.user);
      setParfumes(p.parfumes);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchProfile();
  }, []);

  // drag’n’drop
  useEffect(() => {
    const el = dropRef.current;
    if (!el) return;

    const prevent = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };
    const onEnter = (e: DragEvent) => {
      prevent(e);
      el.classList.add("drop--hover");
    };
    const onLeave = (e: DragEvent) => {
      prevent(e);
      el.classList.remove("drop--hover");
    };
    const onDrop = (e: DragEvent) => {
      prevent(e);
      el.classList.remove("drop--hover");
      const f = e.dataTransfer?.files?.[0];
      if (f) setFile(f);
    };

    el.addEventListener("dragenter", onEnter);
    el.addEventListener("dragover", onEnter);
    el.addEventListener("dragleave", onLeave);
    el.addEventListener("dragend", onLeave);
    el.addEventListener("drop", onDrop);

    return () => {
      el.removeEventListener("dragenter", onEnter);
      el.removeEventListener("dragover", onEnter);
      el.removeEventListener("dragleave", onLeave);
      el.removeEventListener("dragend", onLeave);
      el.removeEventListener("drop", onDrop);
    };
  }, []);

  async function uploadImageIfAny(): Promise<string> {
    if (!file) return "";
    const uid = auth.currentUser?.uid || "anon";
    const path = `users/${uid}/parfumes/${uuid()}-${file.name}`;
    const r = ref(storage, path);
    await uploadBytes(r, file);
    return await getDownloadURL(r);
  }

  async function addParfume() {
    if (!name || busy) return;
    try {
      setBusy(true);
      const imgUrl = await uploadImageIfAny();

      await api("/client/create-parfume", {
        method: "POST",
        body: JSON.stringify({
          name,
          img: imgUrl,
          description: desc || "",
          question: "",
        }),
      });

      nav("/profile"); // возврат после успешного добавления
    } finally {
      setBusy(false);
    }
  }

  if (loading) return <Loading />;

  const blocked = me?.status !== "draft" || parfumes.length >= 5;

  if (blocked) {
    return (
      <div className="cabinet add">
        <div className="add__blocked">
          <h2>Вы не можете добавить больше парфюмов</h2>
          <p>Максимум — 5 парфюмов или этап уже завершён.</p>
          <button className="pill" onClick={() => nav("/profile")}>
            Назад в профиль
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="cabinet">
      <header className="cabinet__top">
        <img src={logo} className="login__logo" />
        <button
          className="pill pill--ghost"
          onClick={() => {
            nav("/profile");
          }}
        >
          Профиль
        </button>
      </header>
      

      <div className="add">
        <h1 className="add__title">Добавить парфюм</h1>
        <div
          ref={dropRef}
          className="dropzone"
          onClick={() => document.getElementById("fileInput")?.click()}
        >
          {file ? (
            <img
              src={URL.createObjectURL(file)}
              alt="preview"
              className="dropzone__preview"
            />
          ) : (
            <div className="dropzone__placeholder">
              <span className="dropzone__icon">📷</span>
              <span>Перетащите фото или нажмите для выбора</span>
            </div>
          )}
          <input
            id="fileInput"
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => setFile(e.target.files?.[0] || null)}
          />
        </div>

        <input
          className="field"
          placeholder="Название на флаконе"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <textarea
          className="field-description"
          placeholder="Ваша ассоциация или история"
          value={desc}
          onChange={(e) => setDesc(e.target.value)}
        />

        <button className="pill-edit" onClick={addParfume} disabled={!name || busy}>
          {busy ? "..." : "Добавить"}
        </button>


        <AssosiationHelper />
      </div>
    </div>
  );
}
